import { createUser, CreateUser } from '@infuse/api/e-connector/user';
import { useNotify } from '@infuse/cpms/ui';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (user: CreateUser) => createUser({}, user),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.users.notify.create.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.users.notify.create.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
